<template>
  <div class="slidecontainer">
    <input type="range" class="slider" :min="min" :max="max" :value="value" @input="e => $emit('input', e.target.value)" />
  </div>
</template>

<script>

export default {
  name: 'slider',
  props: {
    value: {
      type: [ String, Number ],
      validate: n => !isNaN(parseInt(n, 10)),
    },
    min: {
      type: [ String, Number ],
      default: 1,
      validate: n => !isNaN(parseInt(n, 10)),
    },
    max: {
      type: [ String, Number ],
      default: 100,
      validate: n => !isNaN(parseInt(n, 10)),
    }
  },
  data() {
    return {
      default: this.value || this.min,
    };
  },
  methods: {

  },
  components: {}
};
</script>

<style lang="scss">
.slidecontainer {
  margin-top: 0.5em;
  width: 100%; /* Width of the outside container */
}

/* The slider itself */
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: white;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
  border-style: solid;
  border-width: 1px;
  border-color: #ced4da;
  border-radius: 5px;
  background: white;
  height: 1em;
}

/* Mouse-over effects */
.slider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  background: rgba(0, 133, 255, 1);
  -webkit-appearance: none;
  appearance: none;
  width: calc(1.7rem);
  height: calc(1.7rem);
  border-radius: 50%;
  cursor: pointer;
}
.slider::-moz-range-thumb {
  background: rgba(0, 133, 255, 1);
  width:calc(1.7rem); /* Set a specific slider handle width */
  height: calc(1.7rem); /* Slider handle height */
  cursor: pointer; /* Cursor on hover */
  // background: rgba(0, 131, 255, 1);
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/misc/slider.vue